<template>
  <div class="header">
    <div class="icon-back" @click="router.push('/analytics')">
      <LeftOutlined class="icon-arrow"/>
    </div>
    <p class="header-text">Аналитика динамики среднего профиля</p>
  </div>
  <div class="card report-options flex flex-column align-item-start">
    <p>
      Отслеживает изменения средних показателей группы в разные периоды времени, позволяя видеть развитие и тенденции без привязки к конкретным людям.
    </p>
    <div class="report-options__body">
      <div>
        <span class="label">
          Группа
        </span>
        <a-select
            v-model:value="selectedGroup"
            :placeholder="'Выберите группу'"
            style="width: 100%;"
            :not-found-content="'Нет данных'"
            show-arrow
        >
          <a-select-option v-for="item in groupOptions" :key="item.id" :value="item.id">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </div>

      <div class="date-block">
        <div>
          <span class="label">
            Первая дата
          </span>
          <a-date-picker
              v-model:value="date1"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </div>

        <div>
          <span class="label">
            Вторая дата
          </span>
          <a-date-picker
              v-model:value="date2"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </div>
      </div>
    </div>
    <div
      v-if="selectedGroup !== null && date1 && date2"
      class="report-options__btn flex justify-content-center"
    >
      <a-button @click="requestForReport" class="primary-button">
        Сформировать отчет
      </a-button>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref } from "@vue/runtime-core";
import CustomSelect2 from "../../../components/Forms/Fields/CustomSelect2.vue";
import { useStore } from "vuex";
import CustomInput from "../../../components/Forms/Fields/CustomInput.vue";
import {LeftOutlined} from "@ant-design/icons-vue";
import {useRoute, useRouter} from "vue-router";
import {message} from "ant-design-vue";

export default {
  components: {LeftOutlined, CustomSelect2, CustomInput },
  name: "general-dynamic-report-parametres",
  setup(props, context) {
    const store = useStore();
    const selectedGroup = ref(null),
      groupOptions = ref([]),
      date1 = ref(null),
      date2 = ref(null);
    const groups = computed(() => store.state.group.groups);
    const router = useRouter();

    onBeforeMount(() => {
      if (!groups.value)
        store.dispatch("group/getGroups").then(() => {
          groupOptions.value.push({ id: 0, text: "Все сотрудники"});
          groupOptions.value = groupOptions.value.concat(groups.value.map((group) => {
            return { id: group.id, text: group.name };
          }));
        });
      else {
        groupOptions.value.push({ id: 0, text: "Все сотрудники"});
        groupOptions.value = groupOptions.value.concat(groups.value.map((group) => {
          return { id: group.id, text: group.name };
        }));
      }
    });

    const requestForReport = () => {
      const secDate1 = new Date(date1.value),
        secDate2 = new Date(date2.value);
      if (Math.abs(secDate1 - secDate2) >= 7776000000) {
        store.dispatch('group/clearAnalyticsGroupData');
        let currentGroup;

        if (selectedGroup.value !== 0) {
          currentGroup = groups.value.find((el) => el.id === selectedGroup.value);
        }

        store.dispatch('group/setAnalyticsGroupData', {
          group_1: {
            name: currentGroup?.name ?? 'Все сотрудники',
            count: currentGroup?.users_count ?? null,
          },
          group_2: null,
        });

        context.emit("reportRequest", {
          group_id: selectedGroup.value,
          date_first: date1.value,
          date_second: date2.value,
        });
      } else {
        message.error('Интервал между датами должен быть не менее 3-х месяцев');
      }
    };

    return {
      selectedGroup,
      groupOptions,
      groups,
      requestForReport,
      date1,
      date2,
      router
    };
  },
};
</script>

<style>
.header {
  position: fixed;
  top: 0;
  padding: 15px 10px 0 10px;
  display: flex;
  justify-content: center;
  row-gap: 10px;
  column-gap: 25px;
  font-size: 20px;
  font-weight: 600;
  z-index: 25;

  @media (max-width: 910px) {
    font-size: 18px;
  }

  @media (max-width: 865px) {
    padding-top: 0;
    position: relative;
    margin-bottom: 20px;
    column-gap: 10px;
  }
}

.icon-back {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 24px;
  width: 24px;
  height: 24px;
  background-color: #FFFFFF;
  border-radius: 8px;
  cursor: pointer;

  .icon-arrow {
    width: 14px;
    height: 14px;
  }

  &:hover {
    .icon-arrow {
      color: var(--main-green);
    }
  }
}

.header-text {
  margin-bottom: 0;
}

.card {
  padding: 30px 40px;
  min-height: 20vh;


  p {
    margin-bottom: 0;
    padding-left: 0;
    font-size: 14px;
  }
}

.label {
  font-size: 14px;
}

@media (max-width: 768px) {
  .report-options__btn,
  .primary-button {
    width: 100%;
  }
}

.date-block {
  display: flex;
  column-gap: 10px;
}
</style>